import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { isNullOrUndefined } from 'src/app/services/utils';
import { environment } from "../../environments/environment";
import {
  COMMON_CONSTANTS,
  ENTITLEMENT_ACTIVITYNAMES,
  MANAGE_LINE_CONST,
} from "../common/core/common.constants";
import { EnvironmentDetailsService } from "./environment-details.service";
import { HttpCacheService } from "./http-cache.service";
import { AuthHttpService } from "./http-wrapper.service";
import { Subject } from "rxjs";
import { HelperUtilityService } from "./helper-utility.service";
import { PnpClientService } from "src/pnpframework/public-api";
import { Router } from '@angular/router';

@Injectable({
  providedIn: "root",
})
export class EntitlementService {
  authToken: any;
  orgID: any;
  handShakeData: any;
  isEntitlementActivityChanged = new Subject<boolean>();
  euiCodeData: { code: string; euiKey: any; redirectUri: string };

  constructor(
    private httpClient: AuthHttpService,
    private _helperUtilSvc: HelperUtilityService,
    private _envSvc: EnvironmentDetailsService,
    private _cacheSvc: HttpCacheService,
    private _pnpClientService: PnpClientService,
    private router: Router
  ) { }



  entitlementFetchActivityID_ByRoles_OKTA() {
    const httpOptions = {
      ...this.setCommonHeaders(),
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(
        this._envSvc.APIGEE_TOKEN_URLS
          .ENTITLEMENTS_FETCH_ACTIVITIESID_BYROLES_OKTA
      );
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS
        .ENTITLEMENTS_FETCH_ACTIVITIESID_BYROLES_OKTA, httpOptions);
    }
  }


  entitlementFetchActivityID_ByRoles_AHUB() {
    const httpOptions = {
     ...this.setCommonHeaders(),
    };
    return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS
      .ENTITLEMENTS_FETCH_ACTIVITIESID_BYROLES_OKTA, httpOptions).toPromise();
  }

  getEntitlementActivityflag(actionTypeName, selectedItems) {
    let entitlementActivities = this._cacheSvc.getFromSessionStorage(
      COMMON_CONSTANTS.ENTITLEMENT_ACTIVITIES
    );
    if (!isNullOrUndefined(entitlementActivities)) {
      entitlementActivities = JSON.parse(atob(entitlementActivities));
      switch (actionTypeName) {
        case COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_SIM:
        case MANAGE_LINE_CONST.SIM_CHANGE_CTA_TXT:
          if (selectedItems < COMMON_CONSTANTS.LINES_LIMIT) {
            return entitlementActivities.single.simSwap;
          } else {
            return entitlementActivities.bulk.simSwap;
          }
        case MANAGE_LINE_CONST.CHANGE_NUMBER_CTA_TXT:
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.changeNumber;
          } else {
            return entitlementActivities.bulk.changeNumber;
          }
        case COMMON_CONSTANTS.ACTION_HYPERLINK.RESTORE_LINE:
        case MANAGE_LINE_CONST.RESTORE_CTA_TXT:
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.restore;
          } else {
            return entitlementActivities.bulk.restore;
          }
        case COMMON_CONSTANTS.ACTION_HYPERLINK.SUSPEND_LINE:
        case MANAGE_LINE_CONST.SUSPEND_LINES_CTA_TXT:
        case MANAGE_LINE_CONST.SUSPEND_CTA_TXT:
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.suspend;
          } else {
            return entitlementActivities.bulk.suspend;
          }
        case MANAGE_LINE_CONST.TRANSFER_NUMBERS_CTA_TXT:
        case MANAGE_LINE_CONST.TRANSFER_NUMBER_CTA_TXT:
          if (selectedItems <= COMMON_CONSTANTS.COUNT_ONE) {
            return entitlementActivities.single.portIn;
          } else {
            return entitlementActivities.bulk.portIn;
          }
        case MANAGE_LINE_CONST.UPDATE_LINE_IDENTIFIER_CTA_TXT:
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.lineIdentifier;
          } else {
            return entitlementActivities.bulk.lineIdentifier;
          }
        case COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_SERVICES:
        case MANAGE_LINE_CONST.CHANGE_SERVICE_CTA_TXT:
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.changeService;
          } else {
            return entitlementActivities.bulk.changeService;
          }
        case COMMON_CONSTANTS.ACTION_HYPERLINK.VIEW_LINE_HISTORY: {
          return true;
        }
        case COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_RATE_PLAN: {
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.changeRatePlan;
          } else {
            return null;
          } 
        }
        case MANAGE_LINE_CONST.CANCEL_SERVICE_CTA_TXT:{
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.cancelSubscriber;
          } else {
            return null;
          }
        }
        case MANAGE_LINE_CONST.MANAGE_PAIRING_CTA_TXT: {
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.managePairing;
          } else {
            return entitlementActivities.bulk.managePairing;
          }
        }
        case MANAGE_LINE_CONST.STRATEGIC_PORT_IN_CTA_TXT: {
          // Only bulk exists for this flow - no single/multi
          return entitlementActivities.bulk.strategicPortIn;
        }
        case ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION: {
          return entitlementActivities.single.verifyAffiliation;
        }
        case ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES: {
          return entitlementActivities.sidenavLinks.manageLines;
        }
        case ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS: {
          return entitlementActivities.lineDetails;
        }
        case ENTITLEMENT_ACTIVITYNAMES.PARTNER_SUBSCRIPTION_REDEMPTION: {
          return entitlementActivities.partnerSubscriptionRedemption;
        }
        case ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY: {
          return entitlementActivities.sidenavLinks.transactions;
        }
        case ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD: {
          return entitlementActivities.sidenavLinks.approvalDashboard;
        }
        case MANAGE_LINE_CONST.MANAGE_SIM_SWAP_BLOCK_CTA_TXT : {
          if (selectedItems <= COMMON_CONSTANTS.LIMIT) {
            return entitlementActivities.single.manageSimSwapBlock;
          } else {
            return entitlementActivities.bulk.manageSimSwapBlock;
          }
        }
        case ENTITLEMENT_ACTIVITYNAMES.MANAGE_PORT_OUT_PROTECTION_SINGLE: {
          return entitlementActivities.single.managePortOutProtection;
        } 
        case ENTITLEMENT_ACTIVITYNAMES.MANAGE_SIM_LOCK_UNLOCK_SINGLE: {
          return entitlementActivities.single.simLockUnlock;
        } 
        case ENTITLEMENT_ACTIVITYNAMES.MANAGE_SIM_LOCK_UNLOCK_BULK: {
          return entitlementActivities.bulk.simLockUnlock;
        }
        case ENTITLEMENT_ACTIVITYNAMES.MANAGE_PORT_OUT_PROTECTION_BULK: {
          return entitlementActivities.bulk.managePortOutProtection;
        }
        case MANAGE_LINE_CONST.POP_CTA_TXT:
          return entitlementActivities.single.manageTpopSingle 
      }
    } else {
      return false;
    }
  }

  getIamAccessToken(code): any {
    const iamRedirectUrl = environment.iamRedirectUrl;
    const body = {
      code: code,
      redirect_uri: iamRedirectUrl,
    };

    if (this._pnpClientService.isRunningInGlobalNav()) {
      return this._pnpClientService.getTokens();
    }

    return this.httpClient
      .post(this._envSvc.APIGEE_TOKEN_URLS.IAM_TOKEN, body)
      .toPromise();
  }


  getUserActivities(userId, orgID, requestBody) {
    const httpOptions = {
     ...this.setCommonHeaders()
    };

    if (environment.mocked_all || environment.mocked_endpoints) {
      if (environment.USER_ROLE === COMMON_CONSTANTS.IOT) {
        return this.httpClient
        .get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ORG_USER_ACTIVITIES_IOT)
        .toPromise();
      } else {
        return this.httpClient
        .get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ORG_USER_ACTIVITIES_WIRELESS_IAM)
        .toPromise();
      }
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ORG_USER_ACTIVITIES,
        requestBody, httpOptions).toPromise();
    }
  }

  setCommonHeaders() {
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'B2b-Client': this._helperUtilSvc.getClientId(),
          'B2b-Org': this._helperUtilSvc.getOrgID(),
          'transactionID': this._helperUtilSvc.getTransactionID(),
          'authToken': this._helperUtilSvc.getAuthToken(),
        },
      ),
    };
  }

  /**
   *
   * Function checks respective entitlement activity based on
   * defined enforcement
   *
   * @param routePath path found within app
   * @returns true or false based on whether route has entitlement activity associated and user access
   */
    userHasActivityRouteAccess(routePath: string): boolean {
      if (routePath?.includes("/account-management/home") || routePath?.includes("/account-management/lines")) {
        return this.getEntitlementActivityflag(ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES, null);
      } else if (routePath?.includes("/account-management/line-details")) {
        return this.getEntitlementActivityflag(ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS, null);
      } else if (routePath?.includes("/account-management/approval-dashboard")) {
        return this.getEntitlementActivityflag(ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD, null);
      } else if (routePath?.includes("/account-management/transactions/transaction-history") ||
                 routePath?.includes("/account-management/transactions/transaction-details") ||
                 routePath?.includes("/account-management/view-line-history-transaction")) {
        return this.getEntitlementActivityflag(ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY, null);
      }

      // This would mean page is not tied to an entitlement activity
      // so user should be allowed to access it
      return true;
    }

    /**
     * This function, given a routePath, checks to see whether the logged in
     * user has the corresponding entitlement activity
     *
     * In the scenario where the user does not have the proper activity,
     * they will be navigated to a restricted page
     *
     * @param routePath path linked to an activity
     */
    routeToActivityCheck(routePath: string): void {
      if (!this.userHasActivityRouteAccess(routePath)) {
          this.router.navigate([COMMON_CONSTANTS.RESTRICT_PAGE_URL]);
      }
    }
}
